import { CustomWindow } from 'helpers/types';

export const useIugu = () => {
  const { Iugu } = (window as unknown) as CustomWindow;

  return Iugu;
};
